import { render, staticRenderFns } from "./CardDoesntExist.vue?vue&type=template&id=30a02eb0"
import script from "./CardDoesntExist.vue?vue&type=script&lang=js"
export * from "./CardDoesntExist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports